import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';

// ==================== MODAL DE CONFIGURACIÓN DE COOKIES ====================
interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

export default function CookieSettingsModal({ isOpen, onClose, preferences, onPreferencesChange, onSave }: {
  isOpen: boolean;
  onClose: () => void;
  preferences: CookiePreferences;
  onPreferencesChange: (key: string, value: boolean) => void;
  onSave: () => void;
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      role="dialog" 
      aria-modal="true" 
      aria-labelledby="cookie-settings-title"
      className="fixed inset-0 bg-black/60 backdrop-blur-xs flex items-center justify-center z-50 p-4"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden border border-gray-100 flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <h3 id="cookie-settings-title" className="text-xl font-bold text-gray-900">Configuración de Cookies</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 hover:bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label="Cerrar modal de configuración"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5 overflow-y-auto flex-1">
          {/* Cookie Item */}
          <div className="border border-gray-100 rounded-xl p-4 bg-gray-50/30 hover:bg-gray-50/80 transition-colors flex gap-4">
            <div className="flex-1">
              <label htmlFor="cookie-necessary" className="font-bold text-gray-950 block mb-1 cursor-pointer">
                Cookies Necesarias
              </label>
              <p className="text-sm text-gray-600 leading-relaxed">
                Estas cookies son esenciales para que puedas navegar por la web y usar sus funciones, como acceder a áreas seguras o recordar tu estado de consentimiento. No se pueden desactivar.
              </p>
            </div>
            <div className="pt-1">
              <input
                id="cookie-necessary"
                type="checkbox"
                checked={preferences.necessary}
                disabled
                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-not-allowed"
              />
            </div>
          </div>

          {/* Cookie Item */}
          <div className="border border-gray-100 rounded-xl p-4 bg-gray-50/30 hover:bg-gray-50/80 transition-colors flex gap-4">
            <div className="flex-1">
              <label htmlFor="cookie-analytics" className="font-bold text-gray-950 block mb-1 cursor-pointer">
                Cookies de Análisis
              </label>
              <p className="text-sm text-gray-600 leading-relaxed">
                Nos permiten contar las visitas y fuentes de tráfico para medir y mejorar el rendimiento de nuestro sitio web de forma totalmente anónima. Nos ayudan a saber qué páginas son las más y menos populares.
              </p>
            </div>
            <div className="pt-1">
              <input
                id="cookie-analytics"
                type="checkbox"
                checked={preferences.analytics}
                onChange={(e) => onPreferencesChange('analytics', e.target.checked)}
                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer focus:outline-none"
              />
            </div>
          </div>

          {/* Cookie Item */}
          <div className="border border-gray-100 rounded-xl p-4 bg-gray-50/30 hover:bg-gray-50/80 transition-colors flex gap-4">
            <div className="flex-1">
              <label htmlFor="cookie-marketing" className="font-bold text-gray-950 block mb-1 cursor-pointer">
                Cookies de Marketing
              </label>
              <p className="text-sm text-gray-600 leading-relaxed">
                Se utilizan para realizar un seguimiento de los visitantes en las páginas web. La intención es mostrar anuncios que sean relevantes y atractivos para el usuario individual y, por tanto, más valiosos para los editores.
              </p>
            </div>
            <div className="pt-1">
              <input
                id="cookie-marketing"
                type="checkbox"
                checked={preferences.marketing}
                onChange={(e) => onPreferencesChange('marketing', e.target.checked)}
                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer focus:outline-none"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-100 flex gap-3 bg-gray-50/50">
          <button
            onClick={onSave}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-xl font-bold transition-all shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Guardar preferencias
          </button>
          <button
            onClick={onClose}
            className="flex-1 border border-gray-300 hover:border-gray-400 text-gray-700 py-3 px-4 rounded-xl font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
